import { FC } from 'react'
import { Squash as Hamburger, CommonBurgerProps } from 'hamburger-react'
import { theme } from '../../config'

export const Burger: FC<CommonBurgerProps> = (props) => {
  return <Hamburger color={theme.colors.gray[600]} rounded {...props} />
}
